import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import Features from "@/components/Features";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";

const Index = () => {
  const { t } = useTranslation();
  const location = useLocation();
  
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [location]);
  
  return (
    <>
      <Helmet>
        <title>Friendato - AI-Powered Matchmaking | Find Your Perfect Match</title>
        <meta name="description" content="Friendato uses AI to help you find meaningful connections. Experience bot dating simulations, personality analysis, and smart compatibility matching." />
        <link rel="canonical" href="https://friendato.ai/" />
        <meta property="og:title" content="Friendato - AI-Powered Matchmaking" />
        <meta property="og:description" content="Find your perfect match with AI-powered matchmaking." />
        <meta property="og:url" content="https://friendato.ai/" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Navigation />
        <main>
          <Hero />
          <HowItWorks />
          <Features />
          <Testimonials />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
